import {LanguageUtils} from "./LanguageUtils";
import {TranslationView} from "../domain/MessageModel/view/MessageBaseView";


export const MessageUtil = {
    getKey() {
        return LanguageUtils.getLanguage();
    },
    getMessage(message: TranslationView | null): string {
        if (!message) return "";

        const lang = this.getKey() as keyof TranslationView;
        return message[lang]?.trim() || message.nl?.trim() || message.fr?.trim() || message.en?.trim() || "";
    },
    getMessageWithFallBack(message: TranslationView | null,fallBackString :string): string {
        if (!message) return fallBackString;

        const lang = this.getKey() as keyof TranslationView;
        return message[lang]?.trim() || message.nl?.trim() || message.fr?.trim() || message.en?.trim() || fallBackString;
    }
}